
import axios from '@/axios.js'
const apiUrl = 'https://users.evolugy.com/v1/';

export default {
  // EVOLUGY USER ACTIONS
  fetchPatients({ commit, rootState }){
      var config = {
        method: 'get',
        url: apiUrl+'?perPage=70&currentPage=1',
        headers: { 
              'Authorization': 'Bearer '+rootState.AuthToken
        }
    };

    axios(config)
    .then(function (response) {

        console.log(response.data);
        var patients = response.data.data.users.filter(obj => {
          return obj.role == "patient"
        })
        // filtrar users where role = patient
        commit('SET_PATIENTS', patients);

    })
    .catch(function (error) {
        console.log(error);

    });
  },
  addPatient ({ dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      var config = {
          method: 'post',
          url: apiUrl,
          headers: { 
                  'Authorization': 'Bearer '+rootState.AuthToken
          },
          data: payload
      };
      axios(config)
      .then(function (response) {

          console.log(response.data);
          dispatch('fetchPatients');
          resolve(response);

      })
      .catch(function (error) {
          reject(error);
      });
    });
  },
  // 
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user-management/users')
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser (context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateUserEvolugy(payload){
        const authUserKey = Object.keys(window.sessionStorage)
        .filter(item => item.startsWith('firebase:authUser'))[0];

        const authUser = JSON.parse(sessionStorage.getItem(authUserKey));

        commit('SET_BEARER', authUser.stsTokenManager.accessToken);

        setTimeout(() => {
          
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+authUser.stsTokenManager.accessToken
          }
          
        }, 20);
  }
}
